import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, MapMarkerGroupDefaultLabelOrigin, ValuesRecord } from "@mcurros2/microm";
import { moodSmileIcon } from "../../MapMarkerIcons/MapMarkerIcons";

export function GestionPersonalDetallesViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const personal = record[1] as string;
    const puesto = record[2] as string;

    const icon = moodSmileIcon;

    const label: google.maps.MarkerLabel | undefined = undefined;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${personal} - ${puesto}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.green[6],
        label: label,
        labelOrigin: label ? new google.maps.Point(MapMarkerGroupDefaultLabelOrigin.x, MapMarkerGroupDefaultLabelOrigin.y) : undefined,
    }

    return markerProps;
}